import React from 'react'
import {connect} from 'react-redux'
import { reduxForm, FieldArray } from 'redux-form'
import {withStyles} from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormLabel from '@material-ui/core/FormLabel'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import Text from '../../../../../uis/form/text'
import Select from '../../../../../uis/form/select'
import Checkbox from '../../../../../uis/form/checkbox'


const styles = theme => ({
    formcontainer: {
        width: "100%"
    },
    fieldContainer: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column"
    },
    rowContainer: {
        width: 720
    },
    field: {
        marginRight: theme.spacing.unit * 5,
        width: 300,
    },
    formControl: {
        marginTop: theme.spacing.unit * 3
    },
    formGroup: {
        flexDirection: 'row'
    },
    paper: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 750,
        paddingLeft: theme.spacing.unit
    },
    tableCell: {
        width: 50,
        padding:8,
        textAlign: 'center'
    },
    tableCellCover: {
    padding:8
    },
    tableLongCell: {
        padding:8,
        textAlign: 'center'
    }
})
const dataTypes = ['varchar', 'float', 'bigint', 'double','tinyint', 'datetime', 'timestamp', 'int', 'enum', 'text'];

const validate = values => {
    const errors = {}
    if (!values.chineseName) {
      errors.chineseName = '必填'
    }
    if (!values.tableName) {
      errors.tableName = '必填'
    }
    return errors
}
class TableRows extends React.Component {
    render() {
        const {classes,fields} = this.props
        return (<TableBody>
            {(fields || []).map((column, index) => {
                return (
                    <TableRow key={index}>
                        <TableCell>
                            <Text name={`${column}.name`} placeholder="字段名" />
                        </TableCell>
                        <TableCell>
                            <Text name={`${column}.comment`} placeholder="注释" />
                        </TableCell>
                        <TableCell>
                            <Select name={`${column}.dataType`} placeholder="数据类型" data={dataTypes.map(item=>({name: item, value: item}))} />
                        </TableCell>
                        <TableCell>
                            <Text name={`${column}.arg1`} placeholder="参数1" className={classes.tableCell} />
                        </TableCell>
                        <TableCell>
                            <Text name={`${column}.arg2`} placeholder="参数2" className={classes.tableCell} />
                        </TableCell>
                        <TableCell>
                            <Text name={`${column}.defaultValue`} placeholder="默认值" />
                        </TableCell>
                        <TableCell className={classes.tableCellCover}><Checkbox name={`${column}.isNotNull`} /></TableCell>
                        <TableCell className={classes.tableCellCover}><Checkbox name={`${column}.isListShow`} /></TableCell>
                        <TableCell className={classes.tableCellCover}><Checkbox name={`${column}.isListSort`} /></TableCell>
                        <TableCell className={classes.tableCellCover}><Checkbox name={`${column}.isFilter`} /></TableCell>
                        <TableCell className={classes.tableCellCover}><Checkbox name={`${column}.isAdd`} /></TableCell>
                        <TableCell className={classes.tableCellCover}><Checkbox name={`${column}.isUpdate`} /></TableCell>
                        <TableCell className={classes.tableCellCover}><Checkbox name={`${column}.isRequired`} /></TableCell>
                        <TableCell className={classes.tableCellCover}>
                            <IconButton variant="raised" size="small" onClick={() => fields.remove(index)}>
                                <DeleteIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>)
            })}
            <TableFooter>
                <TableRow>
                    <Button
                        variant="raised"
                        color="primary"
                        size="small"
                        style={{marginLeft: 10, marginTop: 10}}
                        onClick={() => fields.push({dataType: 'varchar', isListShow: true, isFilter: true, isAdd: true, isUpdate: true})}
                    >
                        <AddIcon />
                    </Button>
                </TableRow>
            </TableFooter>
        </TableBody>)

    }
}

const renderRoles = ({ fields, classes, roles}) => (
    <FormControl className={classes.formControl}>
        <FormLabel>授权角色</FormLabel>
        <FormGroup className={classes.formGroup}>
            {fields.map((field, index)=>{
                return <Checkbox name={`${field}.${roles[index].name}`} label={roles[index].name} />
            })}
        </FormGroup>
    </FormControl>
  )
class ListForm extends React.Component {
    render() {
        const { handleSubmit, onCancel, pristine, submitting, classes, roles} = this.props
        return (
            <form onSubmit={handleSubmit} className={classes.formcontainer} noValidate autoComplete="off">
                <div className={classes.fieldContainer}>
                    <div className={classes.rowContainer}>
                        <Text name="chineseName" label="模块中文名称" placeholder="请输入模块中文名称" required={true} className={classes.field} />
                        <Text name="tableName" label="表名" placeholder="请输入表名" required={true} className={classes.field} />
                    </div>
                    <div className={classes.rowContainer}>
                        <Text name="defaultSize" label="列表默认行数" placeholder="列表默认行数" required={true} className={classes.field} />
                    </div>
                    <div className={classes.rowContainer}>
                        <FormControl className={classes.formControl}>
                            <FormLabel>功能</FormLabel>
                            <FormGroup className={classes.formGroup}>
                                <Checkbox name="hasAdd" label="新增" />
                                <Checkbox name="hasDelete" label="删除" />
                                <Checkbox name="hasUpdate" label="修改" />
                                <Checkbox name="hasQuery" label="查询" />
                            </FormGroup>
                        </FormControl>
                    </div>
                    <div className={classes.rowContainer}>
                        <FieldArray name={`roles`} component={renderRoles} classes={classes} roles={roles} />
                    </div>
                </div>

                {/* <div className={classes.rowContainer}>
                    <Select name="parentId" label="父菜单名称" placeholder="请选择父菜单" required={true} className={classes.field}>

                        {modules.filter((item,index) => {
                        if (!item.parentName && !item.parentId) {
                            return true
                        }}).map((i,index) => {
                                        return (
                                            <MenuItem key={index} value={i.id}>{i.name}</MenuItem>
                                        )
                        })}
                    </Select>
                    <Text name="diskPath" label="磁盘路径" placeholder="请输入磁盘路径" required={true} className={classes.field}/>
                </div> */}
                <Paper className={classes.paper}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell >表字段</TableCell>
                                <TableCell >注释</TableCell>
                                <TableCell >数据类型</TableCell>
                                <TableCell >参数1</TableCell>
                                <TableCell >参数2</TableCell>
                                <TableCell >默认值</TableCell>
                                <TableCell className={classes.tableCellCover}>不能NULL</TableCell>
                                <TableCell className={classes.tableCellCover}>是否列表展示</TableCell>
                                <TableCell className={classes.tableCellCover}>是否列表排序</TableCell>
                                <TableCell className={classes.tableCellCover}>是否支持筛选</TableCell>
                                <TableCell className={classes.tableCellCover}>是否支持新增</TableCell>
                                <TableCell className={classes.tableCellCover}>是否支持修改</TableCell>
                                <TableCell className={classes.tableCellCover}>是否必填</TableCell>
                                <TableCell className={classes.tableCellCover}>操作</TableCell>
                            </TableRow>
                        </TableHead>
                        <FieldArray name="fields" component={TableRows} classes={classes} roles={roles} />
                    </Table>
                </Paper>
                <div style={{margin: 24,display: 'flex',justifyContent: 'center',width: '100%'}}>
                    <Button type="submit" variant="raised" color="primary" disabled={submitting || pristine}>确定</Button>
                    <Button variant="outlined" onClick={onCancel} style={{marginLeft: 50}}>取消</Button>
                </div>
            </form>
        )
    }
}

export default connect(
    state => ({
      initialValues: {
        defaultSize: 10,
        hasAdd: true,
        hasDelete: true,
        hasUpdate: true,
        hasQuery: true,
        fields:[
            {name: 'id', comment: '主键', dataType: 'bigint', arg1: 11, isNotNull: true},
            {name: 'create_time', comment: '创建时间', dataType: 'timestamp', isNotNull: true, defaultValue: 'CURRENT_TIMESTAMP'},
            {name: 'update_time', comment: '更新时间', dataType: 'timestamp', isNotNull: true, defaultValue: 'CURRENT_TIMESTAMP', isUpdateTimestamp: true}
        ],
        roles: state.modules.roles.map(role=>({[role.name]: role.name === '超级管理员'}))
      }
    }),
  )(reduxForm({
    form: 'modulesForm',
    validate
})(withStyles(styles)(ListForm)))



// WEBPACK FOOTER //
// ./src/pages/home/routes/modules/components/listForm.js